// removed by extract-text-webpack-plugin
module.exports = {"button":"button__button___2TYs6","button--primary":"button__button--primary___3ikoY","button--danger":"button__button--danger___1WUc3","button--link":"button__button--link___22M3J","button--danger-link":"button__button--danger-link___deZsS","invisible":"button__invisible___3cMwI","loading-container":"button__loading-container___3x9sn"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/button.scss
// module id = 1300
// module chunks = 0